import { requestGet, requestPost } from '@/utils/request';

// 动态分页
export function getDynamicPage(params: any) {
  return requestPost(`/v2/camp/api/dynamic/page`, params);
}

// 点赞
export function postPraise(params: { bePraiseId: string; bePraiseUid: number; type: number }) {
  return requestPost(`/v2/camp/api/dynamic/praise`, params);
}

// 动态详情
export function getDynamicDetails(dynamicId: string) {
  return requestGet(`/v2/camp/api/dynamic/id/${dynamicId}`, {});
}

// 获取回复分页
export function getReplyPage(params: { dynamicId: string; current: number; size: number }) {
  return requestPost(`/v2/camp/api/dynamic/reply/page`, params);
}

// 提交动态回复
export function postDynamicReply(params: any) {
  return requestPost(`/v2/camp/api/dynamic/reply`, params);
}

// 提交评论
export function postReplyComments(params: any) {
  return requestPost(`/v2/camp/api/dynamic/comments`, params);
}

// 列举评论
export function getCommentsList(replyId: string) {
  return requestGet(`/v2/camp/api/dynamic/comments/list/${replyId}`, {});
}
